import React from 'react';
import '../style/css/footer.css'
import logofooter from '../style/imges/logofooter.png'
import {Link} from "react-router-dom";


const MainFooter = () => {
    return (
        <div className={'footer-container'}>
            <div className={'logo-container flex ai-c'}>
                <div className={'company'}>BY LEGA6</div>
                <div className={'logo'}><img className={'icon-logo-footer'} src={logofooter}/></div>
            </div>
            <div>
                <Link to={'/logs'}>ארכיון פעולות</Link>
            </div>
        </div>
    );
};

export default MainFooter;